import React, { FC } from "react";
// import { useNavigate } from "react-router-dom";

import {
  Button,
  Icon,
  // InformationItem,
  Modal,
} from "../../common";
// import { BlueBubbleFAQ } from "../../content/blueBubbleFAQ";
// import { ROUTES } from "../../../routes";

type Props = {
  isOpen: boolean;
  close: () => void;
  isOnmetaEligible: boolean;
  isBusiness: boolean;
  isUsdEligible: boolean;
};

export const BlueBubbleModal: FC<Props> = ({
  isOpen,
  close,
  isOnmetaEligible,
  isBusiness,
  isUsdEligible,
}) => {
  // const navigate = useNavigate();
  // const navigateToWallets = () => {
  //   navigate(ROUTES.WALLETS);
  // };
  if (isOnmetaEligible && isBusiness) {
    return (
      <Modal
        isOpen={isOpen}
        close={close}
        title={
          <div className="flex flex-col gap-6">
            <Button
              className="!w-6 !h-6 hidden md:flex"
              icon
              variant={Button.variant.TERTIARY}
              size={Button.size.SMALL}
              onClick={close}
            >
              <Icon icon="Arrow-left" size={24} />
            </Button>

            <h2>First steps...</h2>
          </div>
        }
      >
        <div className="flex flex-col gap-6">
          <div className="mt-2">
            <b>1. Complete Archway Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>to use Archway</li>
              <li>to receive payments from the EU/UK</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>2. Complete Onmeta Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>to enable INR payouts</li>
              <li>
                <b>Please contact support</b> to get help with this process
              </li>
            </ul>
          </div>
          <div className="mt-2">
            <b>3a. Add your INR account details</b>
            <ul className="list-disc list-inside indent-1">
              <li>to get INR payouts to your Indian bank account</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>3b. Add your USDC wallet</b>
            <ul className="list-disc list-inside indent-1">
              <li>(optional )to get USDC payouts for your Invoices</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>Send Invoices to your clients</b>
            <ul className="list-disc list-inside indent-1">
              <li>and get INR payouts to your Indian bank account</li>
              <li>or get USDC payouts to your wallet</li>
            </ul>
          </div>

          <div className="flex justify-center">
            <Button
              className="px-5 contact-support-btn"
              contentClassName="flex gap-5"
              variant={Button.variant.PRIMARY}
            >
              Get Help{" "}
              <Icon
                icon="support_agent"
                size={24}
                className="text-white"
                disableFill
              />
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
  if (isOnmetaEligible) {
    return (
      <Modal
        isOpen={isOpen}
        close={close}
        title={
          <div className="flex flex-col gap-6">
            <Button
              className="!w-6 !h-6 hidden md:flex"
              icon
              variant={Button.variant.TERTIARY}
              size={Button.size.SMALL}
              onClick={close}
            >
              <Icon icon="Arrow-left" size={24} />
            </Button>

            <h2>First steps...</h2>
          </div>
        }
      >
        <div className="flex flex-col gap-6">
          <div className="mt-2">
            <b>1. Complete Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>to use Archway</li>
              <li>to receive payments from the EU/UK</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>2a. Add your INR account details</b>
            <ul className="list-disc list-inside indent-1">
              <li>to get INR payouts to your Indian bank account</li>
              <li>(required for Personal Transfers)</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>2b. Add your USDC wallet</b>
            <ul className="list-disc list-inside indent-1">
              <li>(optional) to get USDC payouts for your Invoices</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>2c. Complete USD Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>(optional) to receive payments in USD</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>Share your Payment Link</b>
            <ul className="list-disc list-inside indent-1">
              <li>
                to accept transfers from <b>family/friends/payers</b> in the
                EU/UK/US and get INR payouts
              </li>
              <li>
                or <b>use it yourself</b> to convert and send your EUR/GBP/USD
                to your INR account
              </li>
            </ul>
          </div>
          <div className="mt-2">
            <b>Send Invoices to your clients</b>
            <ul className="list-disc list-inside indent-1">
              <li>and get INR payouts to your Indian bank account</li>
              <li>or get USDC payouts to your wallet</li>
            </ul>
          </div>

          <div className="flex justify-center">
            <Button
              className="px-5 contact-support-btn"
              contentClassName="flex gap-5"
              variant={Button.variant.PRIMARY}
            >
              Get Help{" "}
              <Icon
                icon="support_agent"
                size={24}
                className="text-white"
                disableFill
              />
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  if (isUsdEligible) {
    return (
      <Modal
        isOpen={isOpen}
        close={close}
        title={
          <div className="flex flex-col gap-6">
            <Button
              className="!w-6 !h-6 hidden md:flex"
              icon
              variant={Button.variant.TERTIARY}
              size={Button.size.SMALL}
              onClick={close}
            >
              <Icon icon="Arrow-left" size={24} />
            </Button>

            <h2>First steps...</h2>
          </div>
        }
      >
        <div className="flex flex-col gap-6">
          <div className="mt-2">
            <b>1. Complete Archway Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>to receive payments from the EU/UK</li>
              <li>to create Invoices</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>2. Add your USDC wallet</b>
            <ul className="list-disc list-inside indent-1">
              <li>to get USDC payouts for your Invoices</li>
            </ul>
          </div>
          <div className="mt-2">
            <b>3. Send Invoices to your clients</b>
            <ul className="list-disc list-inside indent-1">
              <li>get USDC payouts to your wallet</li>
            </ul>
          </div>

          <div className="mt-2">
            <b>4. Complete USD Identity Verification</b>
            <ul className="list-disc list-inside indent-1">
              <li>(optional) to receive payments in USD</li>
            </ul>
          </div>

          <div className="flex justify-center">
            <Button
              className="px-5 contact-support-btn"
              contentClassName="flex gap-5"
              variant={Button.variant.PRIMARY}
            >
              Get Help{" "}
              <Icon
                icon="support_agent"
                size={24}
                className="text-white"
                disableFill
              />
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title={
        <div className="flex flex-col gap-6">
          <Button
            className="!w-6 !h-6 hidden md:flex"
            icon
            variant={Button.variant.TERTIARY}
            size={Button.size.SMALL}
            onClick={close}
          >
            <Icon icon="Arrow-left" size={24} />
          </Button>

          <h2>First steps...</h2>
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        <div className="mt-2">
          <b>1. Complete Archway Identity Verification</b>
          <ul className="list-disc list-inside indent-1">
            <li>to receive payments from the EU/UK</li>
            <li>to create Invoices</li>
          </ul>
        </div>
        <div className="mt-2">
          <b>2. Add your USDC wallet</b>
          <ul className="list-disc list-inside indent-1">
            <li>to get USDC payouts for your Invoices</li>
          </ul>
        </div>
        <div className="mt-2">
          <b>3. Send Invoices to your clients</b>
          <ul className="list-disc list-inside indent-1">
            <li>get USDC payouts to your wallet</li>
          </ul>
        </div>

        <div className="flex justify-center">
          <Button
            className="px-5 contact-support-btn"
            contentClassName="flex gap-5"
            variant={Button.variant.PRIMARY}
          >
            Get Help{" "}
            <Icon
              icon="support_agent"
              size={24}
              className="text-white"
              disableFill
            />
          </Button>
        </div>
      </div>
    </Modal>
  );
};
